import util from '@bmp-vue/core/api/util'

const controller = 'Atividade'
export default Object.assign({}, util.GetCrud(controller, ['getall', 'get', 'put', 'delete']))
